/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unsafe-storage */
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk'; // @ts-expect-error dependency missing types

import SafeStorage from 'SafeStorage'; // @ts-expect-error dependency missing types

import rootReducer from '../reducers'; // @ts-expect-error dependency missing types

import actionCreators from '../actions'; // @ts-expect-error dependency missing types

import LocalStoragePersistenceMiddleware from '../middleware/LocalStoragePersistenceMiddleware'; // @ts-expect-error dependency missing types

import RavenErrorReportingMiddleware from '../middleware/RavenErrorReportingMiddleware'; // @ts-expect-error dependency missing types

import CacheMiddleware from '../middleware/CacheMiddleware'; // @ts-expect-error dependency missing types

import UsageTrackingMiddleware from '../middleware/UsageTrackingMiddleware'; // @ts-expect-error dependency missing types

export function configureStore(initialState) {
  return createStore(rootReducer, initialState, compose(applyMiddleware(thunk, CacheMiddleware, LocalStoragePersistenceMiddleware, RavenErrorReportingMiddleware, UsageTrackingMiddleware), window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__({
    actionCreators
  }) : f => f));
}
export function fetchStateFromStorage(localStorageKey, emptyValue) {
  const value = JSON.parse(SafeStorage.getItem(localStorageKey));
  return value || emptyValue;
}